import * as Yup from 'yup';

export interface IContactDetails {
  mobile_number: string;
  address: IContactAddress;
  birth_address: IContactAddress;
  local_address: IContactAddress;
  // pan_no: string;
  employee_id: string;
}

export interface IContactAddress {
  province: string;
  district: string;
  municipality: string;
  ward_no: string;
  house_num: string;
  tole_street: string;
  block_no: string;
}

export const ContactDetailsInitialValues = {
  mobile_number: '',
  email:"",
  address: {
    province: '',
    district: '',
    municipality: '',
    ward_no: '',
    house_num: '',
    tole_street: '',
    block_no: ''
  },
  birth_address: {
    province: '',
    district: '',
    municipality: '',
    ward_no: '',
    house_num: '',
    tole_street: '',
    block_no: ''
  },
  local_address: {
    province: '',
    district: '',
    municipality: '',
    ward_no: '',
    house_num: '',
    tole_street: '',
    block_no: ''
  },
  // pan_no: '',
  employee_id: ''
};

export const ContactDetailsSchemaValidation = Yup.object().shape({
  mobile_number: Yup.string().required('Mobile Number is required'),
  email: Yup.string().email('Invalid email address').nullable(),
  pan_no: Yup.string().nullable(),
  address: Yup.object().shape({
    province: Yup.string().required('Province is required'),
    district: Yup.string().required('District is required'),
    municipality: Yup.string().required('Municipality is required'),
    ward_no: Yup.string().nullable(),
    house_num: Yup.string().nullable(),
    tole_street: Yup.string().nullable(),
    block_no: Yup.string().nullable()
  }),
  birth_address: Yup.object().shape({
    province: Yup.string().required('Province is required'),
    district: Yup.string().required('District is required'),
    municipality: Yup.string().required('Municipality is required'),
    ward_no: Yup.string().nullable(),
    house_num: Yup.string().nullable(),
    tole_street: Yup.string().nullable(),
    block_no: Yup.string().nullable()
  }),
  local_address: Yup.object().shape({
    province: Yup.string().required('Province is required'),
    district: Yup.string().required('District is required'),
    municipality: Yup.string().required('Municipality is required'),
    ward_no: Yup.string().nullable(),
    house_num: Yup.string().nullable(),
    tole_street: Yup.string().nullable(),
    block_no: Yup.string().nullable()
  })
});
